import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// Icons and Images
import { logo } from "../../assets/images";

// Custom Components
import { InputField, FullLoader } from "../../components";

//Initial State of form & gender Options
import { signUpData, genderOptions } from "./helper";

import { useSignupUserMutation } from "../../redux/services/authApi";

const SignUp = () => {
  const [signupUser, { data, isLoading, error, isError, isSuccess }] =
    useSignupUserMutation();

  const navigate = useNavigate();

  const [userData, setUserData] = useState({ ...signUpData });

  const handleSubmit = (e) => {
    e.preventDefault();
    signupUser(userData);
  };

  useEffect(() => {
    if (isSuccess) {
      setUserData(signUpData);
      toast.success(data?.message);

      setTimeout(() => {
        navigate("/");
      }, 2000);
    }

    if (isError) toast.error(error?.data?.message);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, isError, data, error]);

  const handleChange = ({ target: { name, value } }) =>
    setUserData((prevState) => ({ ...prevState, [name]: value }));

  return (
    <section className="auth-section h-screen flex flex-col md:flex-row">
      {isLoading ? <FullLoader /> : null}

      <div className="h-1/2 md:h-full md:w-1/2 lg:w-fit">
        <img
          src="https://res.cloudinary.com/weebofigurines/image/upload/v1653225337/vibes/signup_bygec0.jpg"
          alt="signupImage"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="flex-1 flex justify-center items-center">
        <form
          className="auth-section__form m-6 p-8 rounded-2xl w-full gap-4 lg:w-6/12 md:gap-0"
          onSubmit={handleSubmit}
        >
          <img className="mx-auto w-32 h-32" src={logo} alt="VibesLogo" />
          <h2 className="mb-4 text-center text-3xl font-bold text-gray-700">
            Create an account!
          </h2>

          <InputField
            type="text"
            labelName="Email"
            autoFocus
            required
            name="email"
            onChange={handleChange}
            value={userData.email}
          />

          <div className="flex flex-col md:flex-row md:gap-8">
            <InputField
              type="text"
              labelName="FullName"
              required
              name="fullName"
              onChange={handleChange}
              value={userData.fullName}
            />

            <InputField
              type="text"
              labelName="Username"
              required
              name="userName"
              onChange={handleChange}
              value={userData.userName}
            />
          </div>

          <div className="flex flex-col md:flex-row md:gap-8">
            <InputField
              type="password"
              labelName="Password"
              required
              name="password"
              minLength={6}
              onChange={handleChange}
              value={userData.password}
            />

            <InputField
              type="password"
              labelName="Confirm Password"
              required
              name="confirmPassword"
              minLength={6}
              onChange={handleChange}
              value={userData.confirmPassword}
              pattern={userData.password}
              title="Password should match!"
            />
          </div>

          <InputField
            type="dropdown"
            labelName="gender"
            options={genderOptions}
            value={userData.gender}
            name="gender"
            onChange={handleChange}
          />

          <button className="bg-blue-300 my-6 p-5 text-gray-600 font-medium text-3xl rounded-lg block w-full hover:bg-blue-500 hover:text-white ease-in duration-150">
            Sign Up
          </button>

          <Link
            to="/"
            className="text-2xl font-medium text-blue-500 hover:text-blue-700 ease-in duration-150"
          >
            Already have an account? Sign In!
          </Link>
        </form>
      </div>
    </section>
  );
};

export default SignUp;
